import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import type { IncidentSeverity } from '../../services/incidentsApi';

type NewIncidentDraft = {
  title: string;
  description: string;
  severity: IncidentSeverity;
  incident_type: string;
  zone: string;
};

type IncidentCreateDialogProps = {
  open: boolean;
  onClose: () => void;
  newIncident: NewIncidentDraft;
  setNewIncident: (value: NewIncidentDraft) => void;
  onCreate: () => void;
};

const IncidentCreateDialog: React.FC<IncidentCreateDialogProps> = ({
  open,
  onClose,
  newIncident,
  setNewIncident,
  onCreate,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Incident</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Title"
            fullWidth
            value={newIncident.title}
            onChange={(e) => setNewIncident({ ...newIncident, title: e.target.value })}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            value={newIncident.description}
            onChange={(e) => setNewIncident({ ...newIncident, description: e.target.value })}
          />
          <FormControl fullWidth>
            <InputLabel>Severity</InputLabel>
            <Select
              value={newIncident.severity}
              label="Severity"
              onChange={(e) => setNewIncident({ ...newIncident, severity: e.target.value as IncidentSeverity })}
            >
              <MenuItem value="low">Low</MenuItem>
              <MenuItem value="medium">Medium</MenuItem>
              <MenuItem value="high">High</MenuItem>
              <MenuItem value="critical">Critical</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              value={newIncident.incident_type}
              label="Type"
              onChange={(e) => setNewIncident({ ...newIncident, incident_type: e.target.value })}
            >
              <MenuItem value="safety">Safety</MenuItem>
              <MenuItem value="ppe">PPE Non-Compliance</MenuItem>
              <MenuItem value="zone">Danger-zone entry</MenuItem>
              <MenuItem value="equipment">Equipment</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Area (optional)"
            fullWidth
            value={newIncident.zone}
            onChange={(e) => setNewIncident({ ...newIncident, zone: e.target.value })}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onCreate} disabled={!newIncident.title}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncidentCreateDialog;
